import { Paper, Stack, Typography } from "@mui/material";
import { ReactElement, ComponentProps } from "react";
import { SxProps } from "@mui/system";

interface Props {
  title: string;
  children: ReactElement;
  sx?: SxProps;
  PaperProps?: ComponentProps<typeof Paper>
}

const DataCard = ({ title, children, sx, PaperProps }: Props) => {
  return (
    <Stack sx={{ width: "100%" }}>
      <Paper {...PaperProps} sx={{ p: 2, ...sx }}>
        <Stack spacing={2}>
          <Stack spacing={2} direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography variant="h4">{title}</Typography>
          </Stack>
          {children}
        </Stack>
      </Paper>
    </Stack>
  );
};

export default DataCard;
